import { Component, EventEmitter, Input, Output } from '@angular/core';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-app-color-selector',
  templateUrl: './app-color-selector.component.html',
  styleUrls: ['./app-color-selector.component.scss']
})
export class AppColorSelectorComponent {
  @Input() public colors: any;

  public updatingColors = false;

  private defaultColors = {
    primary: '29 39 62',
    secondary: '14 86 129',
    prose: '33 37 41',
    page: '255 255 255',
    lightGrey: '245 245 246',
    grey: '139 144 147',
    success: '35 158 66',
    warning: '255 159 10',
    danger: '155 29 32'
  };

  @Output() public updateColors: EventEmitter<any> = new EventEmitter();

  public color(key, values): string {
    if (!values) {
      values = this.defaultColors[key];
    }

    values = values.split(' ');
    const hex = '#' + this.componentToHex(values[0]) + this.componentToHex(values[1]) + this.componentToHex(values[2]);
    return hex;
  }

  public setColor(col, key) {
    this.updatingColors = true;
    const r = parseInt(col.substring(1, 3), 16);
    const g = parseInt(col.substring(3, 5), 16);
    const b = parseInt(col.substring(5, 7), 16);

    this.colors = { ...this.colors, [key]: `${r} ${g} ${b}` };
  }

  private componentToHex(c): string {
    const hex = parseInt(c).toString(16);
    return hex.length == 1 ? '0' + hex : hex;
  }

  public cancelConfigureColors() {
    this.updatingColors = false;
    this.colors = environment.app?.colors;
  }

  public configureColors() {
    this.updatingColors = false;
    return this.updateColors.emit(this.colors);
  }
}
